import { inject, InjectionToken } from '@angular/core';
import { AppEnvironment, BaseEnvironment } from '@mkp/shared/models';

export const ENVIRONMENT_PROVIDER = new InjectionToken<BaseEnvironment>('environmentProvider');

/** For consumers shared with apps that have no API surface; inject this over ENVIRONMENT_PROVIDER. */
export const APP_ENVIRONMENT_PROVIDER = new InjectionToken<AppEnvironment>(
  'appEnvironmentProvider',
  // Falls back to the wide token so an app or TestBed binding only that one still resolves.
  { providedIn: 'root', factory: () => inject(ENVIRONMENT_PROVIDER) }
);
